import React, { useState } from 'react';
import { TrackByPath } from '../SiteHeaderTracking.js';
import { useAppState } from '../AppStateContext.tsx';
import { SiteHeaderNavigation } from './SiteHeaderNavigation.jsx';

export const SiteHeaderMobileNavigation = () => {
  const {
    menuLevel,
    selectedMenu,
    setSelectedMenu,
    setMenuLevel,
    setIsMenuVisible,
    setSelectedCategory,
    setSelectedProductSection,
    isMenuVisible,
  } = useAppState();
  const showMenu = (navigationItem) => {
    setSelectedMenu(navigationItem);
    setIsMenuVisible(true);
    setSelectedCategory(null);
    setSelectedProductSection(null);
    setMenuLevel(2);
  };
  const siteHeaderConfiguration = _THULEDATA._siteHeader;
  const navigation = siteHeaderConfiguration.Navigation;
  const openLanguageSelector = () => {
    if (!_THULEDATA.isExtranet) {
      document.querySelector('button[data-bs-target="#marketSelector"]')?.click();
      TrackByPath('Language selector');
    }
  };
  return (
    <div
      className={`navigation-mobile-menu navigationOverlay menuLevel-${menuLevel} ${isMenuVisible ? 'active' : ''}`}
      id="navigation-mobile-menu"
      aria-expanded={isMenuVisible}
    >
      <nav className={`navigation menuLevel-${menuLevel}`}>
        <ul className="menuFirstLevel">
          {navigation &&
            navigation.map((navigationItem, i) => (
              <li key={i} className={menuLevel > 1 && selectedMenu != navigationItem ? 'd-none' : ''}>
                {navigationItem?.Link ? (
                  <a
                    onClick={() => {
                      TrackByPath(navigationItem.EnglishTitle);
                    }}
                    className={`navigationItem navigationHeading firstLevelMenuItem`}
                    href={navigationItem.Link}
                  >
                    {navigationItem.Title}
                  </a>
                ) : (
                  <>
                    <button
                      onClick={() => {
                        if (navigationItem == selectedMenu) {
                          setIsMenuVisible(false);
                          setMenuLevel(1);
                          setSelectedMenu(null);
                        } else {
                          showMenu(navigationItem);
                          setSelectedMenu(navigationItem);
                          setMenuLevel(2);
                        }
                      }}
                      className={`firstLevelMenuItem btn navigationItem ${selectedMenu == navigationItem && menuLevel > 2 ? 'd-none' : ''}`}
                      aria-expanded={selectedMenu == navigationItem}
                      aria-controls={`navigation-mobile-item-${i}`}
                      aria-label={`${selectedMenu == navigationItem ? 'Close' : 'Open'} menu ${navigationItem.Title}`}
                    >
                      <span className="navigationHeading">{navigationItem.Title}</span>
                      <i aria-hidden="true" className="le-icon-chevron rot-180"></i>
                    </button>
                    <SiteHeaderNavigation
                      navItem={navigationItem}
                      id={`navigation-mobile-item-${i}`}
                      index={i}
                      isActive={selectedMenu == navigationItem}
                      isMobile={true}
                    />
                  </>
                )}
              </li>
            ))}
        </ul>
        <ul className={`d-lg-none menuFirstLevelBottom ${menuLevel === 1 ? '' : 'd-none'}`}>
          <div className="navigationBorder"></div>
          {siteHeaderConfiguration.MyAccountPageLink?.Url && (
            <li>
              <i className="le-icon-user"></i>
              <a
                onClick={() => TrackByPath(NavigationTrackingType.LOGIN)}
                className="navigationItem paragraph--s navigationParagraph"
                href={siteHeaderConfiguration.MyAccountPageLink.Url}
              >
                {siteHeaderConfiguration.MyAccountPageLink.Text}
              </a>
            </li>
          )}
          {siteHeaderConfiguration.DealerLocatorPageLink?.Url && (
            <li>
              <i className="le-icon-map-pin"></i>
              <a
                onClick={() => TrackByPath(NavigationTrackingType.STORES)}
                className="navigationItem paragraph--s navigationParagraph"
                href={siteHeaderConfiguration.DealerLocatorPageLink.Url}
              >
                {siteHeaderConfiguration.DealerLocatorPageLink.Text}
              </a>
            </li>
          )}
          {!_THULEDATA.isExtranet && (
            <li>
              <i className="le-icon-globe"></i>
              <button className="btn navigationItem" onClick={openLanguageSelector}>
                <span className="navigationParagraph">{siteHeaderConfiguration.MarketSelectorIcon?.Title}</span>
              </button>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};
